module.exports = __webpack_public_path__ + "static/media/椭1.b8add42c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/椭1.png
// module id = 1321
// module chunks = 0